/* global Sentry */
/* eslint-disable no-constant-condition */
Sentry.init({
    dsn: "%%dsn%%",
    integrations: [
        new Sentry.Integrations.BrowserTracing({
            beforeNavigate: function(context) {
                var out = Object.assign({}, context);
                out.name = context.name.toLowerCase();
                return out;
            }
        })
    ],
    tracesSampleRate: "%%environment%%"==="development" ? 1 : 0.2,
    release: "%%release%%",
    environment: "%%environment%%"
});